import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../../data-structures/results/result-row.model";


/**
 * Digester Input Flows
 */
interface DIFInterface {
 'RESULTS.DATA.TECHNICAL.FU'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.RD'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.RFW'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.IMFR'?: ResultRow;
}
export class DIF {
  'RESULTS.DATA.TECHNICAL.FU';
  'RESULTS.DATA.TECHNICAL.RD'?;
  'RESULTS.DATA.TECHNICAL.RFW';
  'RESULTS.DATA.TECHNICAL.IMFR';

  get feedstockUsage() {
    return this['RESULTS.DATA.TECHNICAL.FU']
  }
  set feedstockUsage(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.FU'] = value;
  }
  /** Recycled Digestate */
  get rd() {
    return this['RESULTS.DATA.TECHNICAL.RD'];
  }
  set rd(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.RD'] = value;
  }
  /** Required Fresh Water */
  get rfw() {
    return this['RESULTS.DATA.TECHNICAL.RFW'];
  }
  set rfw(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.RFW'] = value;
  }
  /** Influent Mass Flow Rate */
  get imfr() {
    return this['RESULTS.DATA.TECHNICAL.IMFR'];
  }
  set imfr(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.IMFR'] = value;
  }

  constructor(param: DIFInterface = {}) {
    this['RESULTS.DATA.TECHNICAL.FU'] = param['RESULTS.DATA.TECHNICAL.FU']
      ? new ResultRow(param['RESULTS.DATA.TECHNICAL.FU'])
      : new ResultRow();

    if (param['RESULTS.DATA.TECHNICAL.RD']) {
      this['RESULTS.DATA.TECHNICAL.RD'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.RD']);
    }

    this['RESULTS.DATA.TECHNICAL.RFW'] = param['RESULTS.DATA.TECHNICAL.RFW']
      ? new ResultRow(param['RESULTS.DATA.TECHNICAL.RFW'])
      : new ResultRow();

    this['RESULTS.DATA.TECHNICAL.IMFR'] = param['RESULTS.DATA.TECHNICAL.IMFR']
      ? new ResultRow(param['RESULTS.DATA.TECHNICAL.IMFR'])
      : new ResultRow();
  }

  deepCopy() {
    return new DIF(cloneDeep(this));
  }
}
